import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Copy, Wallet, Users, Loader2 } from "lucide-react";

export function ReferralCard() {
  const [data, setData] = useState(null);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const load = async () => {
    try { const { data } = await api.get("/referral/me"); setData(data); setEmail(data.payout_email || ""); }
    catch { /* ignore */ }
  };
  useEffect(() => { load(); }, []);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(data?.link || "");
      toast.success("Lyen kopye!");
    } catch {
      toast.error("Pa ka kopye otomatikman — kopye lyen an manyèlman.");
    }
  };
  const savePayout = async () => {
    setBusy(true);
    try { const { data } = await api.post("/referral/payout-email", { payout_email: email }); setEmail(data.payout_email); toast.success("PayPal anrejistre"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  if (!data) return <div className="text-xs text-[#5f7ba6]">Chajman...</div>;

  return (
    <div className="space-y-4" data-testid="referral-card">
      <p className="text-xs text-[#5f7ba6] -mt-1">
        Pataje lyen w lan. Chak fwa yon moun ou refere peye yon abònman, ou touche <b className="text-[#8fb4e6]">{data.commission_pct}%</b>.
      </p>
      <div>
        <label className="text-xs text-[#888]">Lyen referral ou</label>
        <div className="mt-1 flex items-center gap-2">
          <Input readOnly value={data.link || ""} data-testid="referral-link" className="bg-[#060c18] border-[#14233d] rounded-xl text-[#8fb4e6] text-xs" />
          <Button onClick={copy} data-testid="referral-copy" className="h-10 rounded-xl px-3 text-white hover:opacity-90" style={{ backgroundColor: "var(--sfx-accent)" }}><Copy className="h-4 w-4" /></Button>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2">
        <div className="rounded-xl border border-[#14233d] bg-[#060c18] p-3 text-center">
          <div className="flex items-center justify-center gap-1 text-[#5f7ba6] mb-1"><Users className="h-3.5 w-3.5" /></div>
          <div className="font-heading text-lg font-bold" data-testid="referral-count">{data.referred_count}</div>
          <div className="text-[10px] font-mono-term uppercase text-[#5f7ba6]">Referred</div>
        </div>
        <div className="rounded-xl border border-[#14233d] bg-[#060c18] p-3 text-center">
          <div className="font-heading text-lg font-bold text-[#f5a623]" data-testid="referral-pending">${data.earnings.pending}</div>
          <div className="text-[10px] font-mono-term uppercase text-[#5f7ba6]">Pending</div>
        </div>
        <div className="rounded-xl border border-[#14233d] bg-[#060c18] p-3 text-center">
          <div className="font-heading text-lg font-bold text-[#00F593]" data-testid="referral-paid">${data.earnings.paid}</div>
          <div className="text-[10px] font-mono-term uppercase text-[#5f7ba6]">Paid</div>
        </div>
      </div>
      <div>
        <label className="text-xs text-[#888] flex items-center gap-1.5"><Wallet className="h-3.5 w-3.5" /> Imèl PayPal (pou nou peye w)</label>
        <div className="mt-1 flex items-center gap-2">
          <Input value={email} onChange={(e) => setEmail(e.target.value)} data-testid="payout-email-input"
            placeholder="ou@paypal.com" className="bg-[#060c18] border-[#14233d] rounded-xl" />
          <Button onClick={savePayout} disabled={busy} data-testid="payout-email-save" className="h-10 rounded-xl px-4 text-white hover:opacity-90" style={{ backgroundColor: "var(--sfx-accent)" }}>
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Save"}
          </Button>
        </div>
        <p className="text-[11px] text-[#5f7ba6] mt-1.5">Nou peye komisyon yo manyèlman sou PayPal ou. Asire imèl la kòrèk.</p>
      </div>
    </div>
  );
}
